// components/BarcodeScanner.jsx Bars2Icon
import React, { useState, useEffect, useRef } from 'react';
import { Bars2Icon } from '@heroicons/react/24/outline';

const BarcodeScanner = ({ onScan, onCancel, disabled = false }) => {
  const [scanning, setScanning] = useState(false);
  const scanTimeoutRef = useRef(null);
  const [lastScanTime, setLastScanTime] = useState(0);

  // Continuous scanning handler
  useEffect(() => {
    let barcodeBuffer = '';
    let bufferTimer;

    const handleKeyPress = (e) => {
      // Skip if disabled or key is Enter (scanners send Enter after barcode)
      if (disabled || e.key === 'Enter') {
        if (barcodeBuffer.length >= 3) { // Minimum barcode length
          clearTimeout(bufferTimer);
          handleScanComplete(barcodeBuffer);
        }
        barcodeBuffer = '';
        return;
      }

      // Only process character keys
      if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        barcodeBuffer += e.key;
        clearTimeout(bufferTimer);
        bufferTimer = setTimeout(() => {
          barcodeBuffer = ''; // Reset if no additional keys pressed quickly
        }, 100);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      clearTimeout(bufferTimer);
    };
  }, [disabled]);

  const handleScanComplete = (barcode) => {
    const now = Date.now();
    if (now - lastScanTime < 200) return; // 200ms between scans
    setLastScanTime(now);
    if (!barcode.trim()) return;
    
    setScanning(true);
    onScan(barcode.trim());
    
    // Visual feedback
    clearTimeout(scanTimeoutRef.current);
    scanTimeoutRef.current = setTimeout(() => {
      setScanning(false);
    }, 300);
  };

  return (
    <div className="flex items-center">
      <div className={`p-2 rounded-md flex items-center ${
        scanning 
          ? 'bg-green-100 text-green-800 animate-pulse' 
          : 'bg-blue-50 text-blue-600'
      }`}>
        <Bars2Icon className="h-5 w-5 mr-2" />
        {scanning ? 'Scanning...' : 'Ready to Scan'}
      </div>
    </div>
  );
};

export default BarcodeScanner;